var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { FormLayout } from "../FormLayout";
import { TextField } from "../fields";
import { maxLength, required, useForm, useModel } from '@veeam/core';
import { Button } from "../Button";
import { ErrorMessage } from "../ErrorMessage";
import { useAutoFocus, useLoginFormSubmit } from "./hooks";
import { Spinner } from "../Spinner";
import { INDENT } from "../View";
import { Text, TEXT_SIZE } from "../Text";
import { CONTROL_SIZE } from "../common/public";
var DEFAULT_TEXTS = {
    placeholderIDField: 'Instance ID',
    actionNext: 'Next',
    errorRequired: 'The field is required',
    errorMaxLength: 'The maximum length is {{length}}',
    checkInstanceIdTitle: 'Check instance ID'
};
var LoginButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 112px;\n"], ["\n    min-width: 112px;\n"])));
// TODO: remove after custom field size - Req278819
var FormContainer = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    [data-field-control-container='true'] {\n        width: 320px;\n    }\n"], ["\n    [data-field-control-container='true'] {\n        width: 320px;\n    }\n"])));
export function InstanceCheck(_a) {
    var loading = _a.loading, send = _a.send, busyModel = _a.busyModel, onNext = _a.onNext, customTexts = _a.texts;
    var texts = Object.assign({}, DEFAULT_TEXTS, customTexts);
    var inputRef = useAutoFocus();
    var form = useForm({ id: '' }, {
        validationSchema: {
            id: [required(texts.errorRequired), maxLength(255, texts.errorMaxLength)]
        }
    });
    var internalLoading = useModel(busyModel).value.loading;
    var _b = useLoginFormSubmit({
        form: form,
        handler: send,
        busyModel: busyModel,
        onSuccess: onNext
    }), submit = _b.submit, errorHighlight = _b.errorHighlight, fieldFocusHandler = _b.fieldFocusHandler, keyDownHandler = _b.keyDownHandler, hasError = _b.hasError, error = _b.error;
    loading = loading || internalLoading;
    var hasMessages = hasError;
    return (React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s, onKeyDown: keyDownHandler },
        React.createElement(Text, { size: TEXT_SIZE.xl, trailer: hasMessages ? INDENT.none : INDENT.m }, texts.checkInstanceIdTitle),
        hasError && React.createElement(ErrorMessage, null, error),
        React.createElement(FormContainer, { direction: STACK_DIRECTION.column, gap: STACK_GAP.m },
            React.createElement(FormLayout, { disabled: loading },
                React.createElement(TextField, { field: form.fields.id, controlRef: inputRef, placeholder: texts.placeholderIDField, size: CONTROL_SIZE.full, hasError: errorHighlight, onFocus: fieldFocusHandler })),
            React.createElement(StackView, { direction: STACK_DIRECTION.row, gap: STACK_GAP.s, align: STACK_ALIGN.center },
                React.createElement(LoginButton, { onClick: submit, disabled: loading }, texts.actionNext),
                loading && React.createElement(Spinner, null)))));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=InstacheCheck.js.map